/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line
  if(!customElements.get('product-card-badge')) {
    customElements.define('product-card-badge', class extends HTMLElement {
      constructor() {
        super();
  
        this.currentVariantId = null;
        this.cardItem = this.closest('.product-item');
        this.badgeContainer = this.querySelector('.product__card-badge-container');
        this.variantBadgesJSON = this.querySelector('script[type="application/json"]')?.textContent;
  
        this.observer = new MutationObserver(this.handleMutation.bind(this));
  
        this.updateBadges = this.updateBadges.bind(this);
      }
      
      connectedCallback() {
        if (!this.cardItem || !this.variantBadgesJSON || !this.badgeContainer) {
          return;
        }
  
        this.variantBadgesMap = this.parseVariantBadgesJSON(this.variantBadgesJSON);
        if(!this.variantBadgesMap) {
          return;
        }
  
        this.observer.observe(this.cardItem, {
          attributes: true,
          attributeFilter: ['data-sg-variant-id'],
        });
      }
  
      parseVariantBadgesJSON(json) {
        try {
          return Object.entries(JSON.parse(json)).reduce((acc, [k, v]) => {
            acc.set(k, v.split(','));
            return acc;
          }, new Map());
        } catch (error) {
          console.error('Error parsing variant badges JSON:', error);
          return null;
        }
      }
  
      handleMutation(mutations) {
        mutations.forEach((mutation) => {
          const variantId = mutation.target.getAttribute('data-sg-variant-id');
          if(!variantId || variantId === this.currentVariantId) {
            return;
          }
  
          this.updateBadges(variantId);
        });
      }
  
      updateBadges(variantId) {
        this.currentVariantId = variantId;
  
        const badges = this.variantBadgesMap.get(variantId);
        if(!badges) {
          return this.badgeContainer.replaceChildren();
        }
  
        let newBadges = badges.map((badge) => {
          const badgeElement = document.createElement('div');
          badgeElement.classList.add('product__card-badge');
          badgeElement.textContent = badge;
          return badgeElement;
        });
  
        this.badgeContainer.replaceChildren(...newBadges);
      }
  
      disconnectedCallback() {
        this.observer.disconnect();
      }
    });
  }
  


  
  
  // This class works with any type of app currency switcher, assuming it's appended to the document body.

  // The currency switcher is moved between mobile and desktop containers on resize rather than being duplicated
  // because the underlying apps usually initialize the currency switcher only once. Having multiple instances
  // causes synchronization issues and state management conflicts.
  const SWITCHER_RELOCATOR_MEDIA_QUERY = 566; // Adjust to the theme's breakpoint for mobile header
  const SWITCHER_RELOCATOR_CLASSES = {
    mobileContainer: 'drawer__bottom__row--localization-gift',
    desktopContainer: 'header__desktop__button--localization',
    switcherElement: 'doubly-float' 
  };
  
  class CurrencySwitcherRelocator {
    constructor() {
      this.defaultSwitcherContainer = document.querySelector(`.${SWITCHER_RELOCATOR_CLASSES.desktopContainer}`);
      this.defaultSwitcherMobileContainer = document.querySelector(`.${SWITCHER_RELOCATOR_CLASSES.mobileContainer}`);
      this.switcher = null;
      this.currentMedia = window.innerWidth < SWITCHER_RELOCATOR_MEDIA_QUERY ? 'mobile' : 'desktop';
      
      this.init();
    }

    init() {
      if(!this.defaultSwitcherContainer || !this.defaultSwitcherMobileContainer) return;

      this.setupObserver();
      this.setupResizeHandler();
    }

    setupObserver() {
      this.bodyObserver = new MutationObserver(this.observeCurrencySwitcher.bind(this));
      this.bodyObserver.observe(document.body, {
        childList: true,
        subtree: false
      });

      this.observerDestroyTimeout = setTimeout(() => {
        if (!this.switcher && this.bodyObserver) {
          this.bodyObserver.disconnect();
          console.warn('Currency Switcher not found after 10 seconds, disconnecting observer');
        }
      }, 10000);
    }

    setupResizeHandler() {
      this.resizeHandler = this.debounce(this.handleResize.bind(this), 200);
      window.addEventListener('resize', this.resizeHandler);
    }

    debounce(func, time) {
      let timeout;
      return function () {
        if (func) {
          const funcCall = () => func.apply(this, arguments);
          clearTimeout(timeout);
          timeout = setTimeout(funcCall, time);
        }
      };
    }

    observeCurrencySwitcher(mutationList, observer) {
      for (const mutation of mutationList) {
        if(mutation.addedNodes[0]?.classList?.contains(SWITCHER_RELOCATOR_CLASSES.switcherElement)){
          observer.disconnect();
          this.switcher = mutation.addedNodes[0];
          this.updateSwitcherPosition();
        }
      }
    }

    handleResize() {
      const newMedia = window.innerWidth < SWITCHER_RELOCATOR_MEDIA_QUERY ? 'mobile' : 'desktop';
      if(newMedia === this.currentMedia) return;

      this.currentMedia = newMedia;
      this.updateSwitcherPosition();
    }

    updateSwitcherPosition() {
      const container = this.currentMedia === 'mobile' ? 
        this.defaultSwitcherMobileContainer : 
        this.defaultSwitcherContainer;
      if(!container) return;
      container.classList.remove('hidden');
      container.replaceChildren(this.switcher);
    }

    destroy() {
      if (this.bodyObserver) {
        this.bodyObserver.disconnect();
      }
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }
    }
  }

  const currencySwitcher = new CurrencySwitcherRelocator();



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
